import React from 'react';
import GameWindowHeader from "../GameWindowHeader";
import GameWindowBg from "../GameWindowBg";
import GameData from "../../../gameplay/model/GameData";
import OrderWindowCard from "./OrderWindowCard";
import clock_icon from "../../../images/gameplay_ui/icons/orders/clock.svg"
import ok_icon from "../../../images/gameplay_ui/icons/orders/ok.svg"
import delayed_icon from "../../../images/gameplay_ui/icons/orders/delayed.svg"
import {CargoNames, CLIENT_NAMES, STATION_NAMES} from "../../../constants/Constants";
import GameTabViewUI from "../Tabs/GameTabViewUI";
import {EMPTY_TRAIN_CAR_TYPE} from "../../../gameplay/model/Balance";

export default class OrdersWindow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 0
        }
    }

    selectPage(page) {
        this.setState({
            currentPage: page
        });
    }

    render() {
        let mainStyle = {
            padding: 10
        }
        let scrollStyle = {
            overflowY: "visible",
            overflowX: "hidden",
            height: "230px"
        }
        let content = [];
        let orders = this.state.currentPage === 0 ? GameData.CurrentGame.getOrders() : GameData.CurrentGame.thisYearOrder.filter(x=> x.year === GameData.CurrentGame.year);
        content.push(<OrderWindowCard
            key={'ord'}
            index={0}
            icon={clock_icon}
            code={"Код заказа"}
            client={"Клиент"}
            from={"Станция отпр"}
            to={"Станция назн"}
            cargo={"Груз"}
            day={"День"}
            year={"Год"}
            weight={"Тоннаж"}
            cost={"Тариф"}
            credit={"Ставка кредита"}
            fontSize={10}
            fontWeight={"normal"}
        />)
        let ordersCards = []

        if (GameData.CurrentGame.state > 0 && GameData.CurrentGame.year === 0 && this.state.currentPage === 1) {
            [{
                code: "У1",
                client: "rc",
                cost: 110,
                day: "ПН",
                year: 0,
                fromId: 2,
                toId: 3,
                name: "Уголь",
                weight: 8000,
                credit: 0.08
            }, {
                code: "У2",
                client: "rc",
                cost: 110,
                day: "ВТ",
                year: 0,
                fromId: 2,
                toId: 3,
                name: "Уголь",
                weight: 8000,
                credit: 0.08
            }, {
                client: "ap",
                clientName: "",
                code: "C2",
                cost: 150,
                credit: 0.08,
                day: "ВТ",
                fromId: 2,
                toId: 1,
                trainCarType: "prod",
                weight: 4000,
                year: 0
            }, {
                client: "av",
                clientName: "",
                code: "К2",
                cost: 150,
                credit: 0.08,
                day: "ВТ",
                fromId: 1,
                toId: 0,
                trainCarType: "containerWithCargo",
                weight: 1600,
                year: 0
            }].forEach((order, i) => {
                let weight = order.weight;
                if (weight < 0) {
                    console.log("У заказа отрицательный вес, пропускаем")
                    return;
                }

                ordersCards.push(<OrderWindowCard
                    index={i}
                    key={order.code}
                    icon={order.isLate ? delayed_icon : ok_icon}
                    code={order.code}
                    client={CLIENT_NAMES[order.client] ?? order.clientName}
                    day={order.day}
                    year={order.year}
                    from={STATION_NAMES[order.fromId]}
                    to={STATION_NAMES[order.toId]}
                    cargo={CargoNames[order.trainCarType] ?? order.name}
                    weight={weight > 0 ? weight.toLocaleString() : 0}
                    cost={order.cost + "/т"}
                    credit={order.credit * 100 + "%"}
                    fontSize={12}
                />);
            });
        }

        for (let i = 0; i < orders.length; i++) {
            let order = orders[i];
            if (order.trainCarType === EMPTY_TRAIN_CAR_TYPE || order.weight < 0)
                continue;

            let day = order.day;
            let year = order.year;

            // TODO: тут костыль. Вывод только на фронте
            if (order.code.includes("CRF")) {
                // Если это крафт, то нужно к day прибавить termDelivery
                // Если переполнение, то прибавляем год
                day += order.termDelivery;
                // Всего есть 4 дня
                while (day > 3) {
                    day -= 4;
                    year++;
                }
            }

            ordersCards.push(<OrderWindowCard
                index={i + 2}
                key={i + 2}
                icon={order.isLate ? delayed_icon : ok_icon}
                code={order.code}
                client={CLIENT_NAMES[order.client] ?? order.clientName}
                day={day}
                year={year}
                from={STATION_NAMES[order.fromId]}
                to={STATION_NAMES[order.toId]}
                cargo={CargoNames[order.trainCarType] ?? order.name}
                weight={order.weight.toLocaleString()}
                cost={order.cost + "/т"}
                credit={(order.credit * 100).toFixed(2) + "%"}
                fontSize={12}
            />)
        }
        content = <div style={mainStyle}>
            <div style={{height: "10px"}}></div>
            {<GameTabViewUI width={1010} tabs={["Заказы", "График"]} onSelectedIndex={this.selectPage.bind(this)}/>}
            <div style={{height: "20px"}}></div>
            {content}
            <div style={scrollStyle}>
                {ordersCards}
            </div>
        </div>
        return <div>
            <GameWindowHeader width={1030} height={40} colorStart={"#FFCC33"} colorEnd={"#F2994A"}
                              onHide={this.props.onHide} isClosable={true}/>
            <GameWindowBg width={1030} height={350} value={content}/>
        </div>;
    }
}
